<div class="dialog-wrapper">
  <!-- Head -->
  <div class="head">
    <label class="label-title">Link Sale Channel</label>
    <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
      <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
    </button>
  </div>
  <div class="body">
    <form [formGroup]="form" class="form-wrapper">
      <div class="form-content size size1of1">
        <div class="form-section">
          <div class="form-section-container">
            <div class="form-section-head">
              <label class="typo body-1 fw400 semi-condensed">Please, choose the sale channel to link this subscription.</label>
            </div>
            <div class="form-section-body">
              <div class="form-row">
                <mat-form-field appearance="outline" class="custom-mat-form-field custom-mat-form-field-outline size size1of1">
                  <mat-label>Sales Channel</mat-label>
                  <mat-select required [disabled]="!!_data.integrationId" formControlName="companyIntegration" (valueChange)="onCompanyIntegrationChange($event)" class="custom-mat-select">
                    <mat-option *ngFor="let companyIntegration of collectionOfCompanyIntegration" [value]="companyIntegration" class="custom-mat-option">{{ companyIntegration.displayName }}</mat-option>
                  </mat-select>
                  <mat-error><error-messages [control]="form.get('companyIntegration')"></error-messages></mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="nav">
    <div class="inner">
      <a mat-button disableRipple="true" (click)="onClose()" class="custom-mat-button button-cancel">Cancel</a>
      <button mat-flat-button (click)="onSubmit()" [disabled]="formSubmitted" ngClass="{'is--loading': formSubmitted}" color="primary" class="mat-button custom-mat-button-primary">Link Sale Channel</button>
    </div>
  </div>
</div>
